"use client";
import { useAuthStore } from "@/store/useAuthStore";
import axios from "axios";
import { useEffect } from "react";
import useSWR from "swr";

const fetcher = ([url, token]: [string, string]) =>
  axios
    .get(url, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);

export function useJourneyDailyLimit() {
  const { accessToken, id } = useAuthStore();

  const { data, isLoading, mutate } = useSWR(
    id && accessToken
      ? [
          `${process.env.NEXT_PUBLIC_API_BASE_URL}/journeys/daily-limit/${id}`,
          accessToken,
        ]
      : null,
    fetcher,
    { revalidateOnFocus: true, dedupingInterval: 30000 }
  );

  // Auto-refresh the button when Bangladesh midnight resets the limit
  useEffect(() => {
    if (!data?.resetsAt) return;
    const ms = new Date(data.resetsAt).getTime() - Date.now();
    if (ms <= 0) {
      mutate();
      return;
    }
    const timer = setTimeout(() => mutate(), ms);
    return () => clearTimeout(timer);
  }, [data?.resetsAt, mutate]);

  return {
    limitReached: data?.limitReached ?? false,
    todayCount: data?.todayCount ?? 0,
    resetsAt: data?.resetsAt ? new Date(data.resetsAt) : null,
    loading: isLoading,
    mutate,
  };
}
